// extracted by mini-css-extract-plugin
export default {"label":"CheckboxLabel_label__Tb26j","right":"CheckboxLabel_right__RYq5R"};